module.exports = __webpack_public_path__ + "static/media/box.676a87a9.svg";